export enum Colors {
  White = '#FFFFFF',
  Black = '#000000',
  Grey100 = '#FAFAFA',
  Grey200 = '#F4F4F4',
  Grey300 = '#D3D2D2',
  Grey400 = '#95979D',
  Grey500 = '#62646A',
  Grey600 = '#222325',
  Green100 = '#D8F1E4',
  Green200 = '#A5DEC0',
  Green300 = '#69CD99',
  Green400 = '#42B77A',
  Green500 = '#219358',
  Green600 = '#07703A',
  Pink100 = '#FAE3E3',
  Pink200 = '#EDCFC3',
  Pink300 = '#EBAE9E',
  Pink400 = '#EB8989',
  Pink500 = '#FF5A60',
  Pink600 = '#9E040A',
  Teal100 = '#EDFCFB',
  Teal200 = '#D2F5F3',
  Teal300 = '#A7DAD8',
  Teal400 = '#67B7B4',
  Teal500 = '#38A39C',
  Teal600 = '#007E76',
  Yellow100 = '#FFF8D9',
  Yellow200 = '#FCEBA4',
  Yellow300 = '#ECD884',
  Yellow400 = '#D7CCA5',
  Yellow500 = '#C6B680',
  Yellow600 = '#928869',
  Blue100 = '#E6EBF1',
  Blue200 = '#CDD8E4',
  Blue300 = '#9DB0C6',
  Blue400 = '#4678B3',
  Blue500 = '#214268',
  Blue600 = '#0A223E',
  Purple100 = '#DFDDEE',
  Purple200 = '#D3C5D7',
  Purple300 = '#C1A3C9',
  Purple400 = '#AD84B7',
  Purple500 = '#87678F',
  Purple600 = '#65446D',
  // Basic usage
  Primary = '#000000',
  Error = '#FF5A60',
  Link = '#42B77A',
  LinkHover = '#219358',
  Hint = '#95979D',
  Border = '#D3D2D2',
}
